<script lang="ts">
    import {onMount} from "svelte";
    import {getEmployee} from "$lib/calls/employee";

    export let value;
    export let getEmployeeId = (x) => 0;
    export let projectUuid;

    let employee;

    onMount(() => {
        getEmployee(projectUuid, getEmployeeId(value)).then(x => {
            employee = x;
        })
    })
</script>
{#if employee}
<p>{employee.firstName} {employee.lastName}</p>
{/if}